export enum TimeModeErrorId {
    FUTURE_DURATION = 'TIME_MODE_FUTURE_DURATION',
    TIME_CALCULATION_FAILED = 'TIME_MODE_TIME_CALCULATION_FAILED',
    NETWORK_ERROR = 'NETWORK_ERROR',
}
